function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

var _parentContainer = /*#__PURE__*/_classPrivateFieldLooseKey("parentContainer");

var _container = /*#__PURE__*/_classPrivateFieldLooseKey("container");

var _dimensionsContainerId = /*#__PURE__*/_classPrivateFieldLooseKey("dimensionsContainerId");

var _containerStyle = /*#__PURE__*/_classPrivateFieldLooseKey("containerStyle");

var ImageDimensions = /*#__PURE__*/function () {
  function ImageDimensions() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ImageDimensions);

    Object.defineProperty(this, _containerStyle, {
      get: _get_containerStyle,
      set: void 0
    });
    Object.defineProperty(this, _dimensionsContainerId, {
      get: _get_dimensionsContainerId,
      set: void 0
    });
    Object.defineProperty(this, _container, {
      get: _get_container,
      set: void 0
    });
    Object.defineProperty(this, _parentContainer, {
      get: _get_parentContainer,
      set: void 0
    });
    var parentContainerSelector = options.parentContainerSelector;
    this.parentContainerSelector = parentContainerSelector;
  }

  _createClass(ImageDimensions, [{
    key: "dimensions",
    value: function dimensions(data) {
      var _ref = data || {},
          width = _ref.width,
          height = _ref.height;

      if (!width || !height) {
        return {
          width: null,
          height: null,
          dimensionsText: ''
        };
      }

      var dimensions = {
        width: Math.round(width),
        height: Math.round(height)
      };
      return _objectSpread(_objectSpread({}, dimensions), {}, {
        dimensionsText: "".concat(dimensions.width, "px x ").concat(dimensions.height, "px")
      });
    }
  }, {
    key: "appendContainer",
    value: function appendContainer() {
      if (!_classPrivateFieldLooseBase(this, _container)[_container]) {
        var _classPrivateFieldLoo;

        var el = document.createElement('div');
        el.id = _classPrivateFieldLooseBase(this, _dimensionsContainerId)[_dimensionsContainerId]; // set styles

        Object.entries(_classPrivateFieldLooseBase(this, _containerStyle)[_containerStyle]).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          el.style[key] = value;
        });
        (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _parentContainer)[_parentContainer]) === null || _classPrivateFieldLoo === void 0 ? void 0 : _classPrivateFieldLoo.appendChild(el);
      }
    }
  }, {
    key: "render",
    value: function render(data) {
      var dimensionsContainer = _classPrivateFieldLooseBase(this, _container)[_container];

      if (dimensionsContainer) {
        var _this$dimensions = this.dimensions(data),
            dimensionsText = _this$dimensions.dimensionsText;

        dimensionsContainer.innerText = dimensionsText;
      }
    }
  }]);

  return ImageDimensions;
}();

function _get_parentContainer() {
  return document.querySelector(this.parentContainerSelector);
}

function _get_container() {
  return document.getElementById(_classPrivateFieldLooseBase(this, _dimensionsContainerId)[_dimensionsContainerId]);
}

function _get_dimensionsContainerId() {
  return 'image-dimensions-container';
}

function _get_containerStyle() {
  return {
    position: 'absolute',
    right: '10px',
    bottom: '10px',
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    padding: '0 5px',
    borderRadius: '5px',
    fontSize: '12px',
    height: '20px',
    lineHeight: '20px'
  };
}

export default ImageDimensions;